import { AnzRdEnvironment } from 'global-types';

export const environment: AnzRdEnvironment = {
  production: true,
  env: 'production',
  nydusNetworkApiBaseUrl: 'https://anz-biz-nn.kaligo.com',
  translationBaseUrl: './assets/i18n',
  guardhouseApiUrl: 'https://auth.businessrewards.anz.com',
  clientId: '5227e857-f039-4b37-8cb3-ebff5cae0820',
  connection: 'email',
  scope: 'openid,address,email,phone,profile,custom',
  redirectUri: 'https://www.businessrewards.anz.com',
  stripeApiKey:
    'pk_live_51I3Z9SCcsFvSbXe7nfMwEelEq00oFY3soA9YHCY3aUo9OcbWM4mZgsMrYFNnY6wdEtMDfzYvPG2JDUDI1IXLPueU00SEIMbITO',
  travelEdgeBaseUrl: 'https://anz-biz-travel.kaligo.com',
  brandName: 'ANZ-BIZ',
  shortBrandName: 'ANZ-BIZ',
  hermesMode: 'refresh-token-rotation',
  idleCheckConfig: {
    timeout: 1080,
    promptTimeout: 120,
  },
  sessionCheckPollInterval: 60,
  cookiesConfig: {
    localeCookieName: 'ascenda.locale',
    localeCookieDomain: 'www.businessrewards.anz.com',
  },
  prismicConfig: {
    apiUrl: 'https://ascendaloyalty.prismic.io/api/v2',
    accessToken:
      'MC5ZSFpteHhNQUFDSUFxMERB.fu-_vX3vv73vv73vv70UFu-_vXJQ77-977-977-977-9I--_vU84R--_vR_vv70z77-977-9Ue-_vUNU77-977-9',
  },
  physicalAddressConfig: {
    autocompleteEndpoint:
      'https://api.addressfinder.io/api/au/address/autocomplete/?',
    detailEndpoint: 'https://api.addressfinder.io/api/au/address/metadata/?',
    queryParams: {
      key: '6MEFUL83HYQC4AVWPJT9',
      format: 'json',
      au_paf: '1',
      highlight: '1',
    },
    queryParamOptions: {
      queryKeyword: 'q',
      idKeyword: 'id',
    },
  },
  appId: 'c3a5a449-48c8-44dd-a71f-c1706d029cf1',
  unleashAppName: 'rd-anz-biz-prod',
  unleashClientKey:
    '*:production.ed9dc866a8362d926412ad673806fed91176182036fdca279f983b42',
};
